<template>
    <Component :is="sliceVariationComponent" v-bind="props" />
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {getSliceComponentProps} from '@prismicio/vue';

    import type {MediaSlice} from '@prismicio-types';
    import MediaDefault from './variations/MediaDefault.vue';
    import MediaDemo from './variations/MediaDemo.vue';
    import MediaImageLeft from './variations/MediaImageLeft.vue';
    import MediaProduct from './variations/MediaProduct.vue';
    import MediaVideo from './variations/MediaVideo.vue';
    import MediaVideoLeft from './variations/MediaVideoLeft.vue';
    import {getSliceVariationComponent} from '../../utils/sliceVariations';

    const props = defineProps(getSliceComponentProps<MediaSlice>());

    const variationComponents = {
        default: MediaDefault,
        mediaImageLeft: MediaImageLeft,
        mediaVideo: MediaVideo,
        mediaVideoLeft: MediaVideoLeft,
        mediaProduct: MediaProduct,
        mediaDemo: MediaDemo,
    };

    const sliceVariationComponent = computed(() => getSliceVariationComponent(props.slice, variationComponents));
</script>
